import React from 'react';
import VehicleManagementReport from '../VehicleManagementReport';

export default function ReportVehicleManagement({ sessionObject }) {
//   if(!sessionObject.sessionVariables["modules"].includes("report-vehicle-management")){
//     return;}
  return (
    <div className="page-bilty">
    <VehicleManagementReport sessionObject={sessionObject} />
    </div>
  );
}